export const SampleAddressApis = ({fetcher}) => ({
    getSampleAddress: async (idEntity: string="") => {
        return fetcher.getJson(`/next-api/sample_address/get_sample_address?idEntity=${idEntity}`);
    },
    saveSampleAddress: async (data) => {
        return fetcher.postJson("/next-api/sample_address/add_edit_sample_address", data);
    },
    cassSampleAddress: async (id) => {
        // /next-api/sample_address/cass_sample_address/<id primary of sample address>
        return fetcher.getJson( "/next-api/sample_address/cass_sample_address/" + id);
    },
});
